import React from 'react';

import { Navigate } from '@tanstack/react-router';

import { VeraLoader } from '@/components/VeraLoader';
import { useAuthContext } from '@/data/hooks/auth';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuthContext();

  if (isLoading) {
    return <VeraLoader fullPage />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/" />;
  }

  return <>{children}</>;
};
